module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix npagePage product",
    staticStyle: {
      "margin-bottom": "-15px"
    }
  }, [_c('div', {
    staticClass: "product_list"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "clearfix row"
  }, [_c('div', {
    staticClass: "col-xs-12 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.clickEvent('/ac1')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/4gimg.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.clickEvent('/ac2')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/wifiimg.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.clickEvent('/ac3')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/bluetoothImg.jpg"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pde"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-796972dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aboutContent.vue
// module id = 341
// module chunks = 1